module.exports = __webpack_public_path__ + "static/media/Brands Infographic Desktop  29-02-2024.257100b2.gif";